/**
 * MyTimesheetWidget — cadence selector for the dashboard "My time" panel.
 *
 * NEW FILE. Drop into:
 *   web/src/components/dashboard-widgets/components/MyTimesheetWidget.tsx
 *
 * Renders the existing weekly strip or the new monthly strip based on the
 * `cadence` discriminator on the payload. Keeping the switch in one tiny
 * component means the dashboard section just renders <MyTimesheetWidget/> and
 * never has to know about cadence.
 */

import { MyWeekStrip } from './MyWeekStrip';
import { MyMonthStrip } from './MyMonthStrip';
import type { MyWeekWidget } from '../types';
import type { NavigateToTimesheetsOptions } from '../navigation';

interface MyTimesheetWidgetProps {
  data: MyWeekWidget | undefined;
  loading?: boolean;
  onNavigateToTimesheets?: (options?: NavigateToTimesheetsOptions) => void;
}

export function MyTimesheetWidget(props: MyTimesheetWidgetProps) {
  // Default to weekly when cadence is absent (back-compat with old payloads).
  if (props.data?.cadence === 'MONTHLY') {
    return <MyMonthStrip {...props} />;
  }
  return <MyWeekStrip {...props} />;
}
